import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=7cf3e5cd&scoped=true"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"
import style1 from "./privacyPolicy.vue?vue&type=style&index=1&id=7cf3e5cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf3e5cd",
  null
  
)

export default component.exports